import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import { routes as AppRoutes } from './views/app.routes';

const defaultPath = {
    path: '/',
    redirect: '/call'
};

Vue.use(Router);

let Routes = [defaultPath];

Routes = Routes.concat(AppRoutes);

const router = new Router({
    routes: Routes
});

router.beforeEach(async (to, from, next) => {
    // transGpt是demo测试版本，不走公服接口，直接登录的
    if (to.path === '/transGpt') {
        let token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1SWQiOiJkZW1vIiwicHdkIjoiT1E2SlhhUjdRZGZtS0gxd05hdFJzZz09IiwiaWF0IjoxNzAyOTU4NTU4fQ.fINfulFRiJ3J9Tlf7pyqmY0vZkt23EUj57KaZ_JrkBk';
        localStorage.setItem('token', token);
        store.commit('account/setToken', token);
    }
    if (!localStorage.getItem('token')) { // 看有没有token
        if (to.path !== '/login') next('/login');
        else next();
    } else {
        if (to.path === '/login') next('/call');
        else next();
    }
});

export default router;
